import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import getAllFilters from './getAllFilters';
import FilterTag from './FilterTag';
import { isChecked, isUnChecked } from '../../../../helpers/helper';
import IpaasService from '../../../../services/IpaasService/IpaasService';
import BotService from '../../../../services/BotService/BotService';
import Filter from './Filter';
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../recoil-store/recoil-state';
import './FilterSection.css';

function FilterSection(props) {
    const { t } = useTranslation();
    const [allFilter, setAllFilter] = useState([]);
    const { filter, setFilter } = props;
    const [isLoaded, setIsLoaded] = useState(false);
    const [clear, setClear] = useState(true);
    const [filterTag, setFilterTag] = useState();
    const [rerender, setRerender] = useState(false);
    const [checked, setChecked] = useState([]);
    // const [hasFilter, setHasFilter] = useState(false);
    const [tempChipList, setTempChipList] = useState({});
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        getAllFilter().then((data) => {
            setAllFilter(data);
        });
        setIsLoaded(true);
    }, []);
    useEffect(() => {
        if (Object.keys(tempChipList).length > 0) {
            const tempObj = JSON.parse(JSON.stringify(tempChipList));
            setFilterTag(tempObj);
        }
    }, [tempChipList]);


    const getAllFilter = async () => {
        // Filter Automation Type by name field
        const filter = { atf: { n: ['Integration', 'Bot'] } }
        return await getAllFilters(filter);
    };

    const getBotsWithFilter = async (params) => {
        props.setLoading(true)
        const result = await BotService.getBotsByFilter(params, 'global')
        props.setLoading(false)
        return result;
        // await IpaasService.getIpaas(params, props.tab === 0 ? 'local' : 'global');
    };

    const onChangeHandler = (e, catName, item, id) => {
        let f;
        if (e.target.checked) {
            f = isChecked(catName, id, setFilter, filter, setTempChipList, tempChipList, item);
        } else if (!e.target.checked) {
            f = isUnChecked(catName, id, setFilter, filter, setTempChipList, tempChipList, item);
        }
        filteredData(f);
        // onSubmit();
        // onSubmit();
    };

    const resetButtonHandler = () => {
        setClear(!clear);
        setFilter({});
        setFilterTag({});
        setTempChipList({});
        getBotsWithFilter().then((data) => {
            if (!data?.data.length) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.BOT.' + data?.message),
                    severity: 'error'
                }))
            } else {
                props.setBotArray(data?.data);
                props.setSearchData(data?.data);
            }
        });
    };

    const handleDelete = (e, item, filterTagsI, catName) => {
        isUnChecked(catName, item.item_id, setFilter, filter, setTempChipList, tempChipList);

        setFilterTag(JSON.parse(JSON.stringify(tempChipList)));
        if (checked.includes(item.item_id)) {
            const currentState = checked.splice(checked.indexOf(item.item_id), 1, checked.splice(checked.indexOf(item.item_id + 1), 0));
            setChecked([...checked, currentState]);
        } else {
            setChecked([...checked, item.item_id]);
        }

        if (Object.keys(tempChipList).length === 0) {
            getBotsWithFilter()
                .then((data) => {
                    if (!data?.data?.length) {
                        setAlert(alert => ({
                            ...alert,
                            show: true,
                            message: t('MESSAGES.BOT.' + data?.message),
                            severity: 'error'
                        }))
                    } else {
                        props.setBotArray(data?.data);
                        props.setSearchData(data?.data);
                    }
                });
            // setHasFilter(false);
            setFilter({});
        } else {
            getBotsWithFilter(filter)
                .then((data) => {
                    if (!data?.data?.length) {
                        setAlert(alert => ({
                            ...alert,
                            show: true,
                            message: t('MESSAGES.BOT.' + data?.message),
                            severity: 'error'
                        }))
                    } else {
                        props.setBotArray(data?.data);
                        props.setSearchData(data?.data);
                    }
                });
            setRerender(!rerender);
        }
    };


    function filteredData(f) {
        let filterKeyLen = Object.keys(f).length;
        getBotsWithFilter(filterKeyLen > 0 && f)
            .then((response) => {
                props.setBotArray(response?.data);
                props.setSearchData(response?.data);
            });
        // const tempObj = JSON.parse(JSON.stringify(tempChipList));
        // setFilterTag(tempObj);
    }

    return (
        <>
            {Object.keys(filter)?.length > 0
                && <FilterTag setFilter={setFilter} filterTag={filterTag} handleDelete={handleDelete}
                    resetButtonHandler={resetButtonHandler} />}
            {isLoaded && allFilter.map((item, index) => {
                return (
                    <>
                        <Filter filter={filter} index={index} item={item} clear={clear}
                            onChangeHandler={onChangeHandler} checked={checked} setChecked={setChecked}
                            anchorElAT={props.anchorElAT} setAnchorElAT={props.setAnchorElAT}
                            anchorElBP={props.anchorElBP}
                            setAnchorElBP={props.setAnchorElBP} anchorElSS={props.anchorElSS}
                            anchorElAPP={props.anchorElAPP}
                            setAnchorElSS={props.setAnchorElSS}
                            setAnchorElAPP={props.setAnchorElAPP}
                            anchorElCategory={props.anchorElCategory}
                            setAnchorElCategory={props.setAnchorElCategory}
                        />
                    </>
                );
            })}
        </>
    );
}

export default FilterSection;
